<header class="fixed left-0 top-0 z-30 w-full border-b border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 backdrop-blur">
  <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
    <div class="flex items-center gap-2 cursor-pointer select-none" (click)="goToHome()">
      <div class="grid h-9 w-9 place-items-center rounded-xl">
        <img src="favicon.png" alt="Confocean" class="h-6 w-6" />
      </div>
      <span class="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">Confocean</span>
    </div>

    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        (click)="themeService.toggleTheme()"
        [attr.aria-label]="themeService.isDark() ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
        class="w-9 h-9 rounded-lg transition-all duration-200 hover:bg-slate-100 dark:hover:bg-slate-700"
        [matTooltip]="themeService.isDark() ? 'Light Mode' : 'Dark Mode'">
        <mat-icon class="text-slate-600 dark:text-slate-300">
          {{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}
        </mat-icon>
      </button>
      <button
        class="cursor-pointer rounded-full bg-[#1e3a8a] px-4 py-2 text-sm font-semibold text-white shadow-sm shadow-blue-900/10 transition hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e3a8a]/40"
        (click)="signUp()"
      >
        Join now
      </button>
    </div>
  </div>
</header>
<app-spinner></app-spinner>
<div class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 dark:from-slate-900 dark:via-slate-900 dark:to-indigo-950 pt-24 pb-24 flex items-center">
  <div class="mx-auto w-full max-w-7xl px-4 sm:px-6">
    <div class="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
    <div class="hidden lg:flex lg:flex-col lg:justify-center">
      <div class="max-w-xl">
        <h1 class="text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">
          Manage events with confidence.
        </h1>
        <p class="mt-4 text-base leading-relaxed text-slate-600 dark:text-slate-400">
          Sign in to access your ConfOcean dashboard, monitor registrations, and keep every detail on track.
        </p>
        <div class="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/70 p-4 shadow-sm backdrop-blur">
            <div class="text-sm font-semibold text-slate-900 dark:text-white">Secure access</div>
            <div class="mt-1 text-sm text-slate-600 dark:text-slate-400">Built-in validation and safer login flow.</div>
          </div>
          <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/70 p-4 shadow-sm backdrop-blur">
            <div class="text-sm font-semibold text-slate-900 dark:text-white">Fast workflow</div>
            <div class="mt-1 text-sm text-slate-600 dark:text-slate-400">Jump back into your event operations instantly.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-center lg:justify-end">
      <div class="w-full max-w-md">
        <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-800/80 p-6 shadow-xl shadow-slate-900/5 dark:shadow-black/20 backdrop-blur sm:p-8">
          <div class="flex items-center gap-3">
            <div class="grid h-10 w-10 place-items-center rounded-2xl">
              <img src="favicon.png" alt="Confocean" class="h-6 w-6" />
            </div>
            <div>
              <h2 class="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">Welcome back</h2>
              <p class="mt-0.5 text-sm text-slate-600 dark:text-slate-400">Sign in to continue to Confocean.</p>
            </div>
          </div>

          <form
            [formGroup]="loginForm"
            (ngSubmit)="loginCheck()"
            novalidate
            autocomplete="off"
            class="mt-6 space-y-4"
          >
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  type="text"
                  placeholder="Email or phone"
                  formControlName="email"
                  class="text-base"
                  autocomplete="off"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  (paste)="onEmailPaste($event)"
                  (input)="onEmailInput()"
                />
                <mat-icon matPrefix>mail</mat-icon>
                <mat-error *ngIf="loginForm.get('email')?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="loginForm.get('email')?.hasError('invalidEmail')">
                  Please enter a valid email address (e.g., user&#64;domain.com)
                </mat-error>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [type]="password_show_and_hide ? 'text' : 'password'"
                  placeholder="Password"
                  formControlName="password"
                  class="text-base"
                  maxlength="128"
                  autocomplete="new-password"
                />
                <mat-icon matPrefix>lock</mat-icon>
                <button mat-icon-button matSuffix type="button" (click)="password_show_and_hide = !password_show_and_hide">
                  <mat-icon>{{ password_show_and_hide ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.get('password')?.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('securityViolation')">
                  Security violation detected in password
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('weakPassword')">
                  Password does not meet security requirements
                </mat-error>
              </mat-form-field>
            </div>

            <button
              type="submit"
              [disabled]="!loginForm.valid"
              class="cursor-pointer w-full rounded-full bg-[#1e3a8a] py-2.5 text-base font-semibold text-white shadow-sm shadow-blue-900/10 transition hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e3a8a]/40 disabled:opacity-50"
            >
              Sign in
            </button>
          </form>
        </div>

        <div class="mt-4 text-center text-xs text-slate-500 dark:text-slate-400">
          By continuing, you agree to Confocean's terms and privacy policy.
        </div>
      </div>
    </div>
    </div>
  </div>
</div>

<footer class="w-full border-t border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 py-6 backdrop-blur md:fixed md:bottom-0 md:left-0">
  <div class="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 md:flex-row md:gap-0">
    <div class="flex items-center gap-2">
      <img src="favicon.png" alt="Confocean" class="h-6 w-6" />
      <span class="text-sm font-semibold text-slate-900 dark:text-white">Confocean</span>
      <span class="text-sm text-slate-500 dark:text-slate-400">© 2021</span>
    </div>
    <nav class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-slate-600 dark:text-slate-400">
      <a href="https://confocean.com/user-agreement" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">User Agreement</a>
      <a href="https://confocean.com/privacy-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Privacy Policy</a>
      <a href="https://confocean.com/cookies-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Cookie Policy</a>
      <a href="https://confocean.com/copyright-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Copyright Policy</a>
    </nav>
  </div>
</footer>
